import { styled } from "@mui/material";
import { AppBar as MuiAppBar, AppBarProps as MuiAppBarProps } from "@mui/material";
import { Toolbar } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";

// import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, ThemeProvider } from '@mui/material';

import Header from "../header/header";
// import ThemeSelector from "../../utils/themeSelector";

import "./appbar.scss";
import images from "../../assets/images";
// import { Box } from "@mui/material";

let drawerWidth: any;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

// const getTheme = (selectedTheme: any) => {
//     switch (selectedTheme) {
//         case ThemeSelector.PRIMARY:
//             return themes.redStone;
//         case ThemeSelector.SECONDARY:
//             return themes.blueNavy;
//         case ThemeSelector.TERTIARY:
//             return themes.oliveGreen;
//         default:
//             return themes.redStone;
//     }
// };

// Width of the sidebar when collapsed — must match sidebar.tsx closedMixin
const closedSidebarWidth = (theme: any) => `calc(${theme.spacing(8)} + 1px)`;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => {
  const isRtl = document.body.dir === "rtl";
  const collapsedW = closedSidebarWidth(theme);
  return {
    zIndex: theme.zIndex.drawer + 2,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // Base: always offset by collapsed sidebar so the header never hides behind it
    marginLeft: isRtl ? 0 : collapsedW,
    marginRight: isRtl ? collapsedW : 0,
    width: `calc(100% - ${collapsedW})`,
    ...(open && {
      marginLeft: isRtl ? 0 : drawerWidth,
      marginRight: isRtl ? drawerWidth : 0,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    boxShadow: "none",
    overflow: "visible",
  };
});

export const AppBarWrapper = (props: any) => {
  drawerWidth = props.width;

  // const handleThemeChange = (e: any) => setSelectedTheme(e.target.value);

  return (
    <AppBar
      position="fixed"
      open={props?.open}
      sx={(theme) => ({
        borderBottom: "1px solid",
        borderColor: theme.palette.theme?.secondary[200],
        backgroundColor: theme.palette.theme?.secondary[100],
      })}
    >
      {/* <FormControl>
                <FormLabel id="theme-radio-buttons-group-label">Theme</FormLabel>
                <RadioGroup
                    row
                    value={selectedTheme}
                    onChange={handleThemeChange}
                    aria-labelledby="theme-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                >
                    {Object.keys(ThemeSelector)?.map((variant: any, index: any) => (
                        <FormControlLabel
                            key={index}
                            value={ThemeSelector[variant]}
                            control={<Radio />}
                            label={ThemeSelector[variant]}
                            sx={{
                                '.MuiFormControlLabel-label': {
                                    color: 'theme.text',
                                },
                            }}
                        />
                    ))}
                </RadioGroup>
            </FormControl> */}
      <Toolbar disableGutters sx={{ backgroundColor: 'grey.100', minHeight: '60px !important', p: 0 }}>
        <Header />
      </Toolbar>
      {/* <Header /> */}
    </AppBar>
  );
};

export default AppBarWrapper;
